import { RB } from '@/scripts/constants/store'
import { TRACKER_ADDTOCART } from '@/scripts/constants/tracker'

interface WishlistItem {
  status: string
  oosOptions: string
  category: string
  price: {
    offer: string
  }
  modelSize: string
  modelName: string
  name: string
  stock: number
  image: string
  pdpURL: string
  lenses: {
    value: string
  }
  frame: {
    value: string
  }
  frameMaterial: string
  frameShape: string
}

export class Wishlist {
  static trackAddToCartFromMySelections = (
    multiAnalytics: any,
    itemsWishlist: any[],
    catentryid: number
  ) => {
    const productFromWishlist = itemsWishlist.find((item) => item.catentryId == catentryid)
    const type =
      productFromWishlist.isRemix === 'true'
        ? 'CP'
        : productFromWishlist.isPrescription === 'true'
        ? 'RX'
        : 'STD'
    multiAnalytics.trackEvent({
      event: TRACKER_ADDTOCART,
      value: {
        Products: {
          [productFromWishlist.partnumber]: this.mapProductFromWishlist(productFromWishlist, type),
        },
      },
    })
  }
  static trackAddToCartFromMySelectionsBothProducts = (
    multiAnalytics: any,
    itemsWishlist: any[],
    catentryid1: number,
    catentryid2: number
  ) => {
    const productFromWishlist1 = itemsWishlist.find((item) => item.catentryId == catentryid1)
    const productFromWishlist2 = itemsWishlist.find((item) => item.catentryId == catentryid2)
    const type1 =
      productFromWishlist1.isRemix === 'true'
        ? 'CP'
        : productFromWishlist1.isPrescription === 'true'
        ? 'RX'
        : 'STD'
    const type2 =
      productFromWishlist2.isRemix === 'true'
        ? 'CP'
        : productFromWishlist2.isPrescription === 'true'
        ? 'RX'
        : 'STD'
    multiAnalytics.trackEvent({
      event: TRACKER_ADDTOCART,
      value: {
        Products: {
          [productFromWishlist1.partnumber]: this.mapProductFromWishlist(
            productFromWishlist1,
            type1
          ),
          [productFromWishlist2.partnumber]: this.mapProductFromWishlist(
            productFromWishlist2,
            type2
          ),
        },
      },
    })
  }
  private static mapProductFromWishlist = (productFromWishlist: WishlistItem, type: string) => {
    return {
      Status: productFromWishlist.status,
      OosOptions: productFromWishlist.oosOptions,
      Conf_IsUpcSupported: '1',
      Category: productFromWishlist.category,
      Type: type,
      Engraving: '',
      Price: (productFromWishlist.price && productFromWishlist.price.offer) || '',
      PriceFull: (productFromWishlist.price && productFromWishlist.price.offer) || '',
      Brand: RB,
      Size: productFromWishlist.modelSize,
      Sku: productFromWishlist.modelName,
      ModelName: productFromWishlist.name,
      MoCo: '',
      Stock: productFromWishlist.stock,
      Image: productFromWishlist.image,
      Url: productFromWishlist.pdpURL,
      LensColor: (productFromWishlist.lenses && productFromWishlist.lenses.value) || '',
      LensTechnology: '',
      FrameColor: (productFromWishlist.frame && productFromWishlist.frame.value) || '',
      FrameTechnology: productFromWishlist.frameMaterial,
      Shape: productFromWishlist.frameShape,
      Units: '1',
    }
  }
}
